import React from "react";
import { Container, Card, Form, Row, Col, Button } from "react-bootstrap";
import SchoolHeader from "../components/HospitalHeader";
import Footer from "../components/Footer";
import ChangePassword from "../components/ChangePassword/ChangePassword";
import HospitalInfoCard from "../components/hospitalInfoCard/HospitalInfoCard";

const HospitalProfile = () => {
    return (
        <div className="dashbrd_pg">
            <SchoolHeader />
            <div className="schl_prfl_pg">
                <Container className="custm_container">
                    <div className="prfl_wrap">
                        <div className="pg_hdng mb-4">
                            <h2>Hospital Profile</h2>
                        </div>
                        <div className="prfl_cntnt">
                            <Card className="pg_card">
                                <Card.Body>
                                    <Row>
                                        <Col md={7}>
                                        <HospitalInfoCard edit={true}/>
                                        </Col>
                                        <ChangePassword/>
                                    </Row>
                                 
                                </Card.Body>
                            </Card>
                        </div>
                    </div>
                </Container>
            </div>
            <Footer />
        </div>
    );
};

export default HospitalProfile;
